import { Direction } from "@pageBuilder/typings";
import { MeshUtil } from "./mesh-util";

export class MeshInteractionChecker {
    public static checkAddWidgetAbility(callerWidgetColumn: HTMLElement, direction?: Direction | null): boolean {
        if (direction === "Left" || direction === "Right") {
            const siblingsByDirection = MeshUtil.getSiblingColumnsByDirection(callerWidgetColumn, direction);
            return siblingsByDirection?.emptyColumns?.length > 0
                || siblingsByDirection.notEmptyColumns?.some(e => MeshUtil.getColumnSize(e) > 1)
                || MeshUtil.getColumnSize(callerWidgetColumn) > 1;
        }

        return true;
    }

    public static checkDragWidgetAbility(callerWidgetColumn: HTMLElement, direction?: Direction | null): boolean {
        const row = callerWidgetColumn.closest("[data-mesh-row]");
        const hasEmptyDragStartColumn = !!row?.querySelector(":scope > [data-mesh-col].drag-start.empty");
        return hasEmptyDragStartColumn || this.checkAddWidgetAbility(callerWidgetColumn, direction);
    }
}